import React from "react";

function Foreign() {
  return (
    <div className="text-md text-center">
      You have to submit a certificate of equivalence issued from the <br />
      Cirriculum Development Center (CDC) Sanotimi, Bhaktapur.
    </div>
  );
}

export default Foreign;
